<template>
  <div class="c-common-wrong">
    <header>
      <div class="wrong-bg">
        <i class="wrong-bg__icon"/>
        <p class="wrong-bg__title">
          共同薄弱知识点
        </p>
      </div>
      <div class="wrong-operate">
        <div class="wrong-operate__left">
        <!-- 至少2人答错的目才会进入共性错题，优先为您展示班级错误人数更多和正答率更低的题目 -->
        </div>
        <div class="wrong-operate__right">
        <!-- <div class="right-content"> -->
          <div class="right-content__selected" v-show="topic.length">
            已选择<span class="blue">{{topic.length}}</span>个知识点
          </div>
          <el-button class="right-content__cancel" v-show="topic.length"
          @click="handleCancel">取消</el-button>
          <el-tooltip effect="dark" content="请勾选需要布置的知识点" placement="top" v-if="isDisabled">
            <el-button type="primary" class="right-content__consolidate"
            icon="el-icon-plus" @click="doExercises"
            :class="isDisabled?'right-content__disabled':''"
            >
              布置知识点巩固练习
            </el-button>
          </el-tooltip>
          <el-button type="primary" class="tooltip-hover" icon="el-icon-plus" v-else
            @click="doExercises">
              布置知识点巩固练习
          </el-button>
        <!-- </div> -->
        </div>
      </div>
    </header>

    <!--table列表-->
    <section>
      <el-table
        ref="wrongTable"
        :data="tableData"
        :header-cell-style="{background:'#F0F2F5',color:'#909399'}"
        style="width: 100%"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange">
        <div slot="empty" class="no-data">
          <emptyContent/>
        </div>
        <el-table-column
          type="selection"
          width="55"
          align="center">
        </el-table-column>
        <el-table-column
          label="知识点名称"
          prop="tag_name"
          sortable>
        </el-table-column>
        <!-- <el-table-column
          label="班级平均掌握程度"
          prop="accuracy"
          align="center"
          width="200"
          sortable>
          <template slot-scope="scope">
            <div class="correlation-probability">
              {{ scope.row.accuracy }}%
            </div>
          </template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="wrongCnt"
          align="center"
          label="正答率"
          width="120"
          sortable>
            <template slot-scope="scope">
            <div class="correlation-people">
              {{ scope.row.wrongCnt }}人
            </div>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="low_score_count"
          align="center"
          label="班级未掌握人数"
          width="200"
          sortable>
            <template slot-scope="scope">
            <div class="correlation-people">
              {{ scope.row.low_score_count }}人
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <div @click="getWrongDetail(scope.$index, scope.row)">
              <el-button
                size="mini"
                type="text"
                class="btn-pos"
                >{{scope.row.isExpanded==0?'展开':'折叠'}}</el-button>
              <i :class="scope.row.isExpanded==0?'el-icon-arrow-down':'el-icon-arrow-up'"/>
            </div>
          </template>
        </el-table-column>
        <el-table-column type="expand" width="1">
          <template slot-scope="scope">
          <div class="spread-right">
            <div class="spread-right__header">
              学生（掌握率）
            </div>
            <div class="spread-right__content" v-if="scope.row.stuTotalList.length">
              <div class="content-item" v-for="(child, index) in scope.row.stuTotalList"
              :key="`stu_${index}`" @click="queryStudentReport(child)">
                <span>{{child.student_name}}：{{(child.avg_score*100).toFixed(0)}}%</span>
              </div>
            </div>
            <div class="student-empty" v-else>
              <img src="../../images/empty.png" alt="">
              <p class="empty-text">暂无数据</p>
            </div>
          </div>
          </template>
        </el-table-column>
      </el-table>
    </section>

  </div>
</template>

<script>
import emptyContent from '../../components/empty-content.vue';
import { getWeakCodeList, getStuListByCode } from '@/api/pt';
import storeCreator from '@/utils/store-creator';
import { openTab } from '@/utils';

export default {
  name: 'PracticeOverviewPoint',
  components: {
    emptyContent,
  },
  props: {
    basicInfo: {
      type: Object,
      default: () => {},
    },
    wrongData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialogVisible: false,
      isAssignShow: false,
      topic: [],
      requestCondition: {},
      tableData: [],
      stuTotalList: [],
    };
  },
  computed: {
    isDisabled() {
      return !this.topic.length > 0;
    },
  },
  watch: {
    basicInfo(v) {
      if (v.evaluate_id) {
        this.commonWrong();
      }
    },
  },
  methods: {
    handleSelectionChange(val) {
      console.log('val', val);
      this.topic = val;
    },
    commonWrong() {
      getWeakCodeList({
        evaluate_id: this.basicInfo.evaluate_id,
        school_id: this.$route.query.schoolId,
        class_id: this.basicInfo.class_id,
        school_master_class_id: this.basicInfo.school_master_class_id,
      }).then(({ data }) => {
        this.tableData = data;
        // 默认折叠
        this.tableData.forEach((item) => {
          this.$set(item, 'isExpanded', 0);
          this.$set(item, 'stuTotalList', []);
        });
      });
    },
    getWrongDetail(index, row) {
      console.log(row);
      if (row.isExpanded) {
        this.rowToggle(index, row);
        return;
      }
      getStuListByCode({
        evaluate_id: this.basicInfo.evaluate_id,
        school_id: this.$route.query.schoolId,
        tag_code: row.tag_code,
      }).then(({ data }) => {
        const item = this.tableData[index];
        item.stuTotalList = data.map((child) => child).sort((a, b) => b.avg_score - a.avg_score);
        this.rowToggle(index, row);
      });
    },
    rowToggle(index, row) {
      const { wrongTable } = this.$refs;
      // 获取表格列包含isExpanded进行样式切换
      const expanded = [...this.$refs.wrongTable.$el.getElementsByClassName('el-table__row')];
      expanded.forEach((child, idx) => {
        if (idx === index) {
          if (!child.className.includes('expanded')) {
            this.$set(row, 'isExpanded', 1);
          } else {
            this.$set(row, 'isExpanded', 0);
          }
        }
      });
      wrongTable.toggleRowExpansion(row);
    },
    handleCancel() {
      this.dialogVisible = true;
      this.$refs.wrongTable.clearSelection();
    },
    handleNoArrange() {
      // 清空所有选中数据
      this.dialogVisible = false;
      this.$refs.knowledgeList.clearchange();
    },
    clearchange() {
      this.$refs.wrongTable.clearchange();
    },
    handleGoArrange() {
      // 直接关闭
      this.dialogVisible = false;
    },
    multipleSelection(val) { // 将选中的题目复制给父组件
      this.topic = val;
    },
    doExercises() {
      if (this.topic.length > 0) {
        const store = storeCreator.create('pt');
        store.set('selectedList', JSON.stringify(this.topic));
        this.$router.push({
          path: '/pt/create-weakspot',
          query: {
            subjectId: this.basicInfo.subject_id,
            subjectName: this.basicInfo.subject_name,
            className: this.basicInfo.class_name,
            testId: this.basicInfo.test_id,
            testName: this.basicInfo.test_name,
            classId: this.basicInfo.class_id,
            testType: 3,
          },
        });
        // this.isAssignShow = true;
      }
    },
    queryStudentReport(item) {
      let params = '';
      console.log(item, 'wang');
      if (Number(this.$route.query.fromType) === 3) { // mt
        params = `userId=${item.user_id}&hwId=${this.spreadData[0].evaluate_id}`;
      } else if (Number(this.$route.query.fromType) === 4) {
        params = `userId=${item.user_id}&courseId=${item.course_id}&topicId=${
          item.topic_id}&sectionId=${item.section_id}&subjectId=${
          item.subject_id}&basename=${item.base_name}&sModule=0&noCache=0`;
      }
      const isProduction = !window.location.host.includes('dev');
      // 区分线上和测试环境
      const address = isProduction
        ? 'http://jzjx.classba.cn'
        : 'http://jzjx.test.classba.cn'; // 测试环境
      console.log(params, 'wang');
      if (params) {
        // 跳到报告页需要item.ts_id参数
        const url = `${address}/amt-web/task?${params}`;
        openTab(url);
      }
    },
  },
  mounted() {
    // this.commonWrong();
  },
};
</script>

<style lang="scss" scoped>
.c-common-wrong{
  box-sizing: border-box;
  padding:45px 20px 32px 20px;
  background: #fff;
  header{
  .wrong-bg{
   display: flex;
   align-items: flex-end;
   position: relative;
   &__icon{
    display: block;
    background:url('~@/views/pt/images/class_bg.png');
    background-size:cover;
    width:38px;
    height:29px;
   }
   &__title{
    position: absolute;
    width: 200px;
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 0.8);
    left:15px
   }
   &__remark{
    position: absolute;
    top:5px;
    font-size: 13px;
    width: 600px;
    font-family: PingFangSC-Medium, PingFang SC;
    color:#999;
   }
  }
  .wrong-operate{
    margin-top:15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
   &__left{
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.6);
    margin-left:15px;
   }
   &__right{
    display: flex;
    align-items: center;
    .right-content{
     &__selected{
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      margin-right:16px;
      .blue{
        color: #1989FA;
      }
     }
     &__cancel{
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #606266;
      margin-right:16px;
      width: 120px;
     }
     &__consolidate{
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #FFFFFF;
      width: 181px;
     }
     &__disabled{
      cursor: not-allowed;
      color: #FFF;
      background-color: rgba(17, 31, 44, 0.12);
      border-color:#fff;
     }
    }
   }
  }
 }
 section{
    margin-top:32px;
    .btn-pos{
      margin-right:8px;
    }
  }
  /deep/ .el-table__expanded-cell{
    padding:0;
  }
  /deep/ .el-button--primary.is-disabled{
    color: #FFF;
    background-color: rgba(17, 31, 44, 0.12);
    border-color:#fff;
  }
}
.spread-right{
  width:100%;
  // height:286px;
  height:auto;
  border:1px solid #F0F2F5;
  background:#f5f7fa;
  &__header{
    height:47px;
    text-align:center;
    line-height:47px;
    background:#F0F2F5;
    color:rgb(144, 147, 153);
    font-weight: 600;
    font-size:14px;
    font-family: Arial, Helvetica, sans-serif;
  }
  &__content{
    font-size:14px;
    // height:239px;
    height: auto;
    color:#606266;
    overflow:auto;
    font-family: Arial, Helvetica, sans-serif;
    clear:both;
    .content-item{
      width: 20%;
      height: 47px;
      line-height: 47px;
      text-align: center;
      float: left;
      span{
        cursor: pointer;
        color: #1989fa;
      }
    }
  }
}
</style>
